<template>
    <div id="show_scan_action_prototype">
        <h1 class="ui header">ScanActionPrototype {{ scan_action_prorotype.name }}</h1>
        <div v-if="is_initialized">
            <table class="ui table">
                <thead class="center aligned">
                    <tr>
                        <th class="eight wide">欄位名</th>
                        <th class="eight wide">數值</th>
                    </tr>
                </thead>
                <tbody class="center aligned">
                    <tr>
                        <td>Barcode</td>
                        <td>{{ scan_action_prorotype.barcode }}</td>
                    </tr>
                    <tr>
                        <td>Name</td>
                        <td>{{ scan_action_prorotype.name }}</td>
                    </tr>
                    <tr>
                        <td>Identity</td>
                        <td>{{ scan_action_prorotype.identity }}</td>
                    </tr>
                    <tr>
                        <td>RequiredCondition</td>
                        <td>{{ scan_action_prorotype.required_ability_identity || 'null' }}</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <table class="ui six column stack table" v-for="(status_prototypes, scope) in scope_grouped_status_prototypes" :status_prototypes="status_prototypes">
                                <thead>
                                    <tr>
                                        <th>{{ human_scope(scope) }}</th>
                                        <th>綁定物料</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="status_prototype in status_prototypes" :status_prototype="status_prototype">
                                        <td>
                                            <i class="plus icon" v-if="status_prototype.polarity == true"></i>
                                            <i class="minus icon" v-else-if="status_prototype.polarity == false"></i>
                                            {{ status_prototype.name || '-' }}
                                        </td>
                                        <td>{{ status_prototype.material_class_name || '無' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderScanActionPrototypesShow",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            scan_action_prorotype: {},
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "scan_action_prorotype") {
                this.init()
            }
        },
    },
    computed: {
        // ordered_status_prototypes() {
        //     return _.orderBy(this.scan_action_prorotype.status_prototypes, ['scope', 'name'], ['asc', 'asc'])
        // },
        scope_grouped_status_prototypes() {
            return _.groupBy(this.scan_action_prorotype.status_prototypes, 'scope')
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.scan_action_prorotype = {}
                this.errors = []
                resolve()
            })
            await this.fetch_scan_action_prototype()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        fetch_scan_action_prototype() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_scan_action_prototype).parse(
                {
                    "scan_action_prototype_identity": this.$route.params.identity,
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    console.log(response)
                    this.scan_action_prorotype = response.data.scan_action_prototype
                })
                .catch(error => {
                    // this.$noty.error('取得掃描動作失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.scan_action_prototypes'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        },
        human_scope(original_scope) {
            switch (original_scope) {
                case "operator":
                    return "內部貨況"
                    break
                case "forwarder":
                    return "客戶貨況"
                    break
                case "public":
                    return "公開貨況"
                    break
                case "mark":
                    return "標記"
                    break
                case "condition":
                    return "流程控制"
                    break
                default:
                    return "不明"
            }
        },
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>
pre {
    outline: 1px solid #ccc;
    padding: 5px;
    margin: 5px;
    .string { color: green; }
    .number { color: darkorange; }
    .boolean { color: blue; }
    .null { color: magenta; }
    .key { color: red; }
}
</style>
